module.exports = function (THREE) {
  return {
    computeTangents: function (p6166) {
      function f867(p6167, p6168, p6169) {
        v5151.fromArray(v5146, p6167 * 3);
        v5152.fromArray(v5146, p6168 * 3);
        v5153.fromArray(v5146, p6169 * 3);
        v5154.fromArray(v5148, p6167 * 2);
        v5155.fromArray(v5148, p6168 * 2);
        v5156.fromArray(v5148, p6169 * 2);
        v5152.sub(v5151);
        v5153.sub(v5151);
        v5155.sub(v5154);
        v5156.sub(v5154);
        var v5142 = 1 / (v5155.x * v5156.y - v5156.x * v5155.y);
        if (isFinite(v5142)) {
          v5157.copy(v5152).multiplyScalar(v5156.y).addScaledVector(v5153, -v5155.y).multiplyScalar(v5142);
          v5158.copy(v5153).multiplyScalar(v5155.x).addScaledVector(v5152, -v5156.x).multiplyScalar(v5142);
          vA280[p6167].add(v5157);
          vA280[p6168].add(v5157);
          vA280[p6169].add(v5157);
          vA281[p6167].add(v5158);
          vA281[p6168].add(v5158);
          vA281[p6169].add(v5158);
        }
      }
      function f868(p6170) {
        v5170.fromArray(v5147, p6170 * 3);
        v5171.copy(v5170);
        v5166 = vA280[p6170];
        v5168.copy(v5166);
        v5168.sub(v5170.multiplyScalar(v5170.dot(v5166))).normalize();
        v5169.crossVectors(v5171, v5166);
        v5167 = v5169.dot(vA281[p6170]);
        v5165 = v5167 < 0 ? -1 : 1;
        v5150[p6170 * 4] = v5168.x;
        v5150[p6170 * 4 + 1] = v5168.y;
        v5150[p6170 * 4 + 2] = v5168.z;
        v5150[p6170 * 4 + 3] = v5165;
      }
      var v5143 = p6166.index;
      var v5144 = p6166.attributes;
      if (v5143 === null || v5144.position === undefined || v5144.normal === undefined || v5144.uv === undefined) {
        console.error("THREE.BufferGeometryUtils: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
        return;
      }
      var v5145 = v5143.array;
      var v5146 = v5144.position.array;
      var v5147 = v5144.normal.array;
      var v5148 = v5144.uv.array;
      var v5149 = v5146.length / 3;
      if (v5144.tangent === undefined) {
        p6166.setAttribute("tangent", new THREE.BufferAttribute(new Float32Array(v5149 * 4), 4));
      }
      var v5150 = v5144.tangent.array;
      var vA280 = [];
      var vA281 = [];
      for (var vLN0776 = 0; vLN0776 < v5149; vLN0776++) {
        vA280[vLN0776] = new THREE.Vector3();
        vA281[vLN0776] = new THREE.Vector3();
      }
      var v5151 = new THREE.Vector3();
      var v5152 = new THREE.Vector3();
      var v5153 = new THREE.Vector3();
      var v5154 = new THREE.Vector2();
      var v5155 = new THREE.Vector2();
      var v5156 = new THREE.Vector2();
      var v5157 = new THREE.Vector3();
      var v5158 = new THREE.Vector3();
      var v5159 = p6166.groups;
      if (v5159.length === 0) {
        v5159 = [{
          start: 0,
          count: v5145.length
        }];
      }
      for (var vLN0776 = 0, v5172 = v5159.length; vLN0776 < v5172; ++vLN0776) {
        var v5173 = v5159[vLN0776];
        var v5174 = v5173.start;
        var v5175 = v5173.count;
        for (var vV5174 = v5174, v5176 = v5174 + v5175; vV5174 < v5176; vV5174 += 3) {
          f867(v5145[vV5174 + 0], v5145[vV5174 + 1], v5145[vV5174 + 2]);
        }
      }
      var v5165;
      var v5166;
      var v5167;
      var v5168 = new THREE.Vector3();
      var v5169 = new THREE.Vector3();
      var v5170 = new THREE.Vector3();
      var v5171 = new THREE.Vector3();
      for (var vLN0776 = 0, v5172 = v5159.length; vLN0776 < v5172; ++vLN0776) {
        var v5173 = v5159[vLN0776];
        var v5174 = v5173.start;
        var v5175 = v5173.count;
        for (var vV5174 = v5174, v5176 = v5174 + v5175; vV5174 < v5176; vV5174 += 3) {
          f868(v5145[vV5174 + 0]);
          f868(v5145[vV5174 + 1]);
          f868(v5145[vV5174 + 2]);
        }
      }
    },
    mergeGeometries: function (p6171, p6172) {
      const v5177 = p6171[0].index !== null;
      const v5178 = new Set(Object.keys(p6171[0].attributes));
      const v5179 = new Set(Object.keys(p6171[0].morphAttributes));
      const vO146 = {};
      const vO147 = {};
      const v5180 = p6171[0].morphTargetsRelative;
      const v5181 = new THREE.BufferGeometry();
      let vLN0777 = 0;
      for (let vLN0778 = 0; vLN0778 < p6171.length; ++vLN0778) {
        const v5182 = p6171[vLN0778];
        let vLN0779 = 0;
        if (v5177 !== (v5182.index !== null)) {
          console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + vLN0778 + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
          return null;
        }
        for (const v5183 in v5182.attributes) {
          if (!v5178.has(v5183)) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + vLN0778 + ". All geometries must have compatible attributes; make sure \"" + v5183 + "\" attribute exists among all geometries, or in none of them.");
            return null;
          }
          if (vO146[v5183] === undefined) {
            vO146[v5183] = [];
          }
          vO146[v5183].push(v5182.attributes[v5183]);
          vLN0779++;
        }
        if (vLN0779 !== v5178.size) {
          console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + vLN0778 + ". Make sure all geometries have the same number of attributes.");
          return null;
        }
        if (v5180 !== v5182.morphTargetsRelative) {
          console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + vLN0778 + ". .morphTargetsRelative must be consistent throughout all geometries.");
          return null;
        }
        for (const v5184 in v5182.morphAttributes) {
          if (!v5179.has(v5184)) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + vLN0778 + ".  .morphAttributes must be consistent throughout all geometries.");
            return null;
          }
          if (vO147[v5184] === undefined) {
            vO147[v5184] = [];
          }
          vO147[v5184].push(v5182.morphAttributes[v5184]);
        }
        if (p6172) {
          let v5185;
          if (v5177) {
            v5185 = v5182.index.count;
          } else if (v5182.attributes.position !== undefined) {
            v5185 = v5182.attributes.position.count;
          } else {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed with geometry at index " + vLN0778 + ". The geometry must have either an index or a position attribute");
            return null;
          }
          v5181.addGroup(vLN0777, v5185, vLN0778);
          vLN0777 += v5185;
        }
      }
      if (v5177) {
        let vLN0780 = 0;
        const vA282 = [];
        for (let vLN0781 = 0; vLN0781 < p6171.length; ++vLN0781) {
          const v5186 = p6171[vLN0781].index;
          for (let vLN0782 = 0; vLN0782 < v5186.count; ++vLN0782) {
            vA282.push(v5186.getX(vLN0782) + vLN0780);
          }
          vLN0780 += p6171[vLN0781].attributes.position.count;
        }
        v5181.setIndex(vA282);
      }
      for (const v5187 in vO146) {
        const v5188 = this.mergeAttributes(vO146[v5187]);
        if (!v5188) {
          console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + v5187 + " attribute.");
          return null;
        }
        v5181.setAttribute(v5187, v5188);
      }
      for (const v5189 in vO147) {
        const v5190 = vO147[v5189][0].length;
        if (v5190 === 0) {
          break;
        }
        v5181.morphAttributes = v5181.morphAttributes || {};
        v5181.morphAttributes[v5189] = [];
        for (let vLN0783 = 0; vLN0783 < v5190; ++vLN0783) {
          const vA283 = [];
          for (let vLN0784 = 0; vLN0784 < vO147[v5189].length; ++vLN0784) {
            vA283.push(vO147[v5189][vLN0784][vLN0783]);
          }
          const vMergeAttributes = mergeAttributes(vA283);
          if (!vMergeAttributes) {
            console.error("THREE.BufferGeometryUtils: .mergeGeometries() failed while trying to merge the " + v5189 + " morphAttribute.");
            return null;
          }
          v5181.morphAttributes[v5189].push(vMergeAttributes);
        }
      }
      return v5181;
    },
    mergeAttributes: function (p6173) {
      var v5191;
      var v5192;
      var v5193;
      var v5194;
      var vLN0785 = 0;
      for (var vLN0788 = 0; vLN0788 < p6173.length; ++vLN0788) {
        v5194 = p6173[vLN0788];
        if (v5194.isInterleavedBufferAttribute) {
          console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. InterleavedBufferAttributes are not supported.");
          return null;
        }
        if (v5191 === undefined) {
          v5191 = v5194.array.constructor;
        }
        if (v5191 !== v5194.array.constructor) {
          console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
          return null;
        }
        if (v5192 === undefined) {
          v5192 = v5194.itemSize;
        }
        if (v5192 !== v5194.itemSize) {
          console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
          return null;
        }
        if (v5193 === undefined) {
          v5193 = v5194.normalized;
        }
        if (v5193 !== v5194.normalized) {
          console.error("THREE.BufferGeometryUtils: .mergeAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
          return null;
        }
        vLN0785 += v5194.array.length;
      }
      var v5195 = new v5191(vLN0785);
      var vLN0787 = 0;
      for (var vLN0788 = 0; vLN0788 < p6173.length; ++vLN0788) {
        v5195.set(p6173[vLN0788].array, vLN0787);
        vLN0787 += p6173[vLN0788].array.length;
      }
      return new THREE.BufferAttribute(v5195, v5192, v5193);
    },
    interleaveAttributes: function (p6174) {
      var v5196;
      var v5201;
      var vLN0789 = 0;
      var vLN0790 = 0;
      for (var vLN0791 = 0, v5200 = p6174.length; vLN0791 < v5200; ++vLN0791) {
        v5201 = p6174[vLN0791];
        if (v5196 === undefined) {
          v5196 = v5201.array.constructor;
        }
        if (v5196 !== v5201.array.constructor) {
          console.error("AttributeBuffers of different types cannot be interleaved");
          return null;
        }
        vLN0789 += v5201.array.length;
        vLN0790 += v5201.itemSize;
      }
      var v5199 = new THREE.InterleavedBuffer(new v5196(vLN0789), vLN0790);
      var vLN0792 = 0;
      var vA284 = [];
      var vA285 = ["getX", "getY", "getZ", "getW"];
      var vA286 = ["setX", "setY", "setZ", "setW"];
      for (var vLN0793 = 0, v5200 = p6174.length; vLN0793 < v5200; vLN0793++) {
        var v5201 = p6174[vLN0793];
        var v5202 = v5201.itemSize;
        var v5203 = v5201.count;
        var v5204 = new THREE.InterleavedBufferAttribute(v5199, v5202, vLN0792, v5201.normalized);
        vA284.push(v5204);
        vLN0792 += v5202;
        for (var vLN0794 = 0; vLN0794 < v5203; vLN0794++) {
          for (var vLN0795 = 0; vLN0795 < v5202; vLN0795++) {
            v5204[vA286[vLN0795]](vLN0794, v5201[vA285[vLN0795]](vLN0794));
          }
        }
      }
      return vA284;
    },
    estimateBytesUsed: function (p6175) {
      var vLN0796 = 0;
      for (var v5205 in p6175.attributes) {
        var v5206 = p6175.getAttribute(v5205);
        vLN0796 += v5206.count * v5206.itemSize * v5206.array.BYTES_PER_ELEMENT;
      }
      var v5207 = p6175.getIndex();
      vLN0796 += v5207 ? v5207.count * v5207.itemSize * v5207.array.BYTES_PER_ELEMENT : 0;
      return vLN0796;
    },
    mergeVertices: function (p6176, p6177 = 0.0001) {
      p6177 = Math.max(p6177, Number.EPSILON);
      var vO148 = {};
      var v5208 = p6176.getIndex();
      var v5209 = p6176.getAttribute("position");
      var v5210 = v5208 ? v5208.count : v5209.count;
      var vLN0797 = 0;
      var v5211 = Object.keys(p6176.attributes);
      var vO149 = {};
      var vO150 = {};
      var vA287 = [];
      var vA288 = ["getX", "getY", "getZ", "getW"];
      var vA289 = ["setX", "setY", "setZ", "setW"];
      for (var vLN0799 = 0, v5223 = v5211.length; vLN0799 < v5223; vLN0799++) {
        var v5234 = v5211[vLN0799];
        var v5214 = p6176.attributes[v5234];
        vO149[v5234] = new THREE.BufferAttribute(new v5214.array.constructor(v5214.count * v5214.itemSize), v5214.itemSize, v5214.normalized);
        var v5226 = p6176.morphAttributes[v5234];
        if (v5226) {
          vO150[v5234] = new THREE.BufferAttribute(new v5226.array.constructor(v5226.count * v5226.itemSize), v5226.itemSize, v5226.normalized);
        }
      }
      var v5216 = Math.log10(1 / p6177);
      var v5217 = Math.pow(10, v5216);
      for (var vLN0799 = 0; vLN0799 < v5210; vLN0799++) {
        var v5218 = v5208 ? v5208.getX(vLN0799) : vLN0799;
        var vLS16 = "";
        for (var vLN0802 = 0, v5223 = v5211.length; vLN0802 < v5223; vLN0802++) {
          var v5234 = v5211[vLN0802];
          var v5225 = p6176.getAttribute(v5234);
          for (var v5227 = v5225.itemSize, vLN0803 = 0; vLN0803 < v5227; vLN0803++) {
            vLS16 += ~~(v5225[vA288[vLN0803]](v5218) * v5217) + ",";
          }
        }
        if (vLS16 in vO148) {
          vA287.push(vO148[vLS16]);
        } else {
          for (var vLN0802 = 0, v5223 = v5211.length; vLN0802 < v5223; vLN0802++) {
            var v5234 = v5211[vLN0802];
            var v5225 = p6176.getAttribute(v5234);
            var v5226 = p6176.morphAttributes[v5234];
            for (var v5227 = v5225.itemSize, v5228 = vO149[v5234], v5229 = vO150[v5234], vLN0803 = 0; vLN0803 < v5227; vLN0803++) {
              var v5230 = vA288[vLN0803];
              var v5231 = vA289[vLN0803];
              v5228[v5231](vLN0797, v5225[v5230](v5218));
              if (v5226) {
                for (var vLN0804 = 0, v5232 = v5226.length; vLN0804 < v5232; vLN0804++) {
                  v5229[vLN0804].push(v5226[vLN0804][v5230](v5218));
                }
              }
            }
          }
          vO148[vLS16] = vLN0797;
          vA287.push(vLN0797);
          vLN0797++;
        }
      }
      const v5233 = p6176.clone();
      for (var v5234 in p6176.attributes) {
        var v5235 = vO149[v5234];
        v5233.setAttribute(v5234, new THREE.BufferAttribute(v5235.array.slice(0, vLN0797 * v5235.itemSize), v5235.itemSize, v5235.normalized));
        if (v5234 in vO150) {
          for (let vLN0805 = 0; vLN0805 < vO150[v5234].length; vLN0805++) {
            var v5236 = vO150[v5234][vLN0805];
            v5233.morphAttributes[v5234][vLN0805] = new THREE.BufferAttribute(v5236.array.slice(0, vLN0797 * v5236.itemSize), v5236.itemSize, v5236.normalized);
          }
        }
      }
      v5233.setIndex(vA287);
      return v5233;
    },
    toTrianglesDrawMode: function (p6178, p6179) {
      if (p6179 === THREE.TrianglesDrawMode) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return p6178;
      }
      if (p6179 === THREE.TriangleFanDrawMode || p6179 === THREE.TriangleStripDrawMode) {
        var v5237 = p6178.getIndex();
        if (v5237 === null) {
          var vA290 = [];
          var v5238 = p6178.getAttribute("position");
          if (v5238 !== undefined) {
            for (var vLN0807 = 0; vLN0807 < v5238.count; vLN0807++) {
              vA290.push(vLN0807);
            }
            p6178.setIndex(vA290);
            v5237 = p6178.getIndex();
          } else {
            console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
            return p6178;
          }
        }
        var v5239 = v5237.count - 2;
        var vA291 = [];
        if (p6179 === THREE.TriangleFanDrawMode) {
          for (var vLN0807 = 1; vLN0807 <= v5239; vLN0807++) {
            vA291.push(v5237.getX(0));
            vA291.push(v5237.getX(vLN0807));
            vA291.push(v5237.getX(vLN0807 + 1));
          }
        } else {
          for (var vLN0807 = 0; vLN0807 < v5239; vLN0807++) {
            if (vLN0807 % 2 == 0) {
              vA291.push(v5237.getX(vLN0807));
              vA291.push(v5237.getX(vLN0807 + 1));
              vA291.push(v5237.getX(vLN0807 + 2));
            } else {
              vA291.push(v5237.getX(vLN0807 + 2));
              vA291.push(v5237.getX(vLN0807 + 1));
              vA291.push(v5237.getX(vLN0807));
            }
          }
        }
        if (vA291.length / 3 != v5239) {
          console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        }
        var v5240 = p6178.clone();
        v5240.setIndex(vA291);
        v5240.clearGroups();
        return v5240;
      }
      console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", p6179);
      return p6178;
    }
  };
};